import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Admin section nav — plain, functional, same tokens as the rest.
 * Non-admins never see this (parent page is behind RequireAdmin).
 */
const LINKS = [
  { to: "/admin/moderation", label: "Moderation" },
  { to: "/admin/mappings", label: "Price mappings" },
  { to: "/admin/catalog", label: "Catalog & cache" },
];

export default function AdminNav() {
  const { pathname } = useLocation();
  return (
    <nav data-testid="admin-nav" className="mb-6 flex flex-wrap gap-2">
      {LINKS.map((l) => {
        const active = pathname === l.to;
        return (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`admin-nav-${l.label.toLowerCase().split(" ")[0]}`}
            className={
              "rounded-chip border px-3 py-1.5 text-meta transition-colors duration-cc ease-cc-ease " +
              (active
                ? "border-indigo-text bg-indigo-chip-bg text-indigo-chip-text"
                : "border-ink-chip bg-ink-surface text-ink-muted hover:border-ink-muted hover:text-ink-text")
            }
          >
            {l.label}
          </Link>
        );
      })}
    </nav>
  );
}
